
export default {
    props: {
        appear: {
            type: Boolean,
            default: false,
        },
        animationStyle: {
            type: String,
            default: 'default',
            /** @param {string} val */
            validator(val) {
                return ['default', 'slideIn'].includes(val);
            },
        },
        direction: {
            type: String,
            default: 'vertical',
            /** @param {string} val */
            validator(val) {
                return ['vertical', 'horizontal'].includes(val);
            },
        },
    },
    computed: {
        slideIn() {
            return this.animationStyle === 'slideIn';
        },
    },
    methods: {
        /** @param {HTMLElement} el */
        beforeEnter(el) {
            this.$emit('before-enter');

            if (this.slideIn && this.direction === 'vertical') {
                el.style.removeProperty('display');
                const elHeight = getComputedStyle(el).height;
                el.style.transform = `translateY(-${elHeight})`;
                el.style.overflow = 'visible';
                el.style.height = '1px';
                el.offsetHeight; // force repaint
                el.style.height = elHeight;
            }
        },
        /** @param {HTMLElement} el */
        async enter(el) {
            if (this.direction === 'horizontal') {
                el.style.width = 'auto';
                const elWidth = getComputedStyle(el).width;
                el.style.width = '1px';
                el.offsetWidth; // force repaint
                el.style.width = elWidth;
            } else if (this.direction === 'vertical') {
                el.style.height = 'auto';
                const elHeight = getComputedStyle(el).height;
                el.style.height = '1px';
                el.offsetHeight; // force repaint
                el.style.height = elHeight;
                if (this.slideIn) {
                    el.style.transform = 'translateY(0px)';
                }
            }
        },
        /** @param {HTMLElement} el */
        afterEnter(el) {
            if (this.direction === 'horizontal') {
                el.style.removeProperty('width');
            } else if (this.direction === 'vertical') {
                el.style.removeProperty('height');
                if (this.slideIn) {
                    el.style.removeProperty('transform');
                    el.style.removeProperty('overflow');
                }
            }
            this.$emit('enter');
        },
        /** @param {HTMLElement} el */
        beforeLeave(el) {
            this.$emit('before-leave');

            if (this.direction === 'horizontal') {
                el.style.width = getComputedStyle(el).width;
                el.offsetWidth; // force repaint
                el.style.width = '0px';
            } else if (this.direction === 'vertical') {
                const elHeight = getComputedStyle(el).height;
                el.style.height = elHeight;
                el.offsetHeight; // force repaint
                el.style.height = '0px';
                if (this.slideIn) {
                    el.style.transform = `translateY(-${elHeight})`;
                    el.style.overflow = 'visible';
                }
            }
        },
        /** @param {HTMLElement} el */
        afterLeave(el) {
            if (this.direction === 'horizontal') {
                el.style.removeProperty('width');
            } else if (this.direction === 'vertical') {
                el.style.removeProperty('height');
                if (this.slideIn) {
                    el.style.removeProperty('transform');
                    el.style.removeProperty('overflow');
                }
            }
            this.$emit('leave');
        },
    },
};
